import { isTrackingEnabled } from './tracking';
const LEAD_CONVERSION = 'AW-18351073049/BYZkCPviif0cEJnOvK5E';
const WHATSAPP_CONVERSION = 'AW-18351073049/zDNMCOyc1IEdEJnOvK5E';

function reportConversion(destination) {
  if (!isTrackingEnabled() || typeof window.gtag !== 'function') return;
  try {
    window.gtag('event', 'conversion', { send_to: destination });
  } catch {
    // Tracking must never interrupt a successful form submission or navigation.
  }
}

export function reportLeadConversion(status) {
  if (status === 200) reportConversion(LEAD_CONVERSION);
}

export function reportWhatsAppConversion() {
  reportConversion(WHATSAPP_CONVERSION);
}
